<template>
  <vs-prompt
    class="dialog-input-risk-level-input"
    @accept="handleAccept(riskLevel)"
    @cancel="handleCancel"
    @close="handleClose"
    :color="color"
    :active="active"
    :title="title"
    :accept-text="acceptText"
    :cancel-text="cancelText"
  >
    <div class="dialog-input-risk-level-input-form flex flex-col">
      <div class="dialog-input-reason-basic flex flex-col">
        <div class="input-label">
          このターゲットオブジェクトの危険性評価を
          <div class="emphasize-risk-level">
            <span class="font-semibold">「{{ riskLevelLabel }}」</span
            >に設定します
          </div>
        </div>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { RadarGridMixin } from "@/mixins";

export default {
  name: "DialogInputRiskLevel",
  mixins: [RadarGridMixin],
  props: {
    title: { type: String, default: "危険性評価" },
    acceptText: { type: String, default: "OK" },
    cancelText: { type: String, default: "キャンセル" },
    color: { type: String, default: "#2D9CDB" },

    radarDetectedObjectId: { Type: String, require: true },
    riskLevel: { Type: Number, require: true },
    handleCancel: { Type: Function, require: false },
    handleClose: { Type: Function, require: false },
    handleAccept: { Type: Function, require: false },
    active: { Type: Boolean, default: false },
  },
  computed: {
    riskLevelLabel() {
      if (this.riskLevel === this.RG_RISK_LEVEL_CANCELED) {
        return this.RG_RISK_LEVEL_FEEDBACK_CANCEL.labelJa;
      }
      return this.RADAR_GRID_OBJECT_RISK_LEVEL[this.riskLevel].labelJa;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.dialog-input-risk-level-input {
  &.con-vs-dialog {
    .vs-dialog {
      max-width: 370px;
    }
    .dialog-input-risk-level-input-form {
      row-gap: 16px;
      .dialog-input-reason-basic {
        row-gap: 16px;
        font-family: $aisea-font-family;
        color: #757575;
      }
      .input-label {
        font-family: $aisea-font-family;
        font-size: 14px;
        line-height: 21px;
        color: #757575;
      }
    }
    .vs-dialog footer {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
    }
  }
}
</style>
